<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import DadosProjetos from './compartilhado/FormDadosProjetos.vue';
  import solicitacaoPagamentoServico from '../../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  
  export default {
    components: { DadosCadastrais, DadosPagamento, DadosBancarios, AdicionarArquivos, ListaDeArquivos, DadosProjetos },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Pagamento de Pessoa Jurídica (Rateio) - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-pagamento-rateio-pj.nova';
    },
    methods: {
      buscarBeneficiario() {
        $('#avancar').button('loading');
        
        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');
            
            this.solicitacao.solicitacao.documentoTerceiro = pessoa.cpfCnpj; 
            this.solicitacao.solicitacao.nomeTerceiro = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.solicitacao.endereco = pessoa.endereco.substring(0, 60);
            this.solicitacao.solicitacao.numero = pessoa.numero.substring(0, 10);
            this.solicitacao.solicitacao.complemento = pessoa.complemento.substring(0, 80);
            this.solicitacao.solicitacao.bairro = pessoa.bairro.substring(0, 60);
            this.solicitacao.solicitacao.cidade = pessoa.cidade.substring(0, 60);
            this.solicitacao.solicitacao.uf = pessoa.estado.substring(0, 2);
            this.solicitacao.solicitacao.cep = pessoa.cep;
            this.solicitacao.solicitacao.pisPasep = pessoa.pisPasep;
            this.solicitacao.solicitacao.telefoneResidencial = pessoa.telefone1;
            this.solicitacao.solicitacao.telefoneComercial = pessoa.telefone2;
            this.solicitacao.solicitacao.fax = pessoa.fax;
            this.solicitacao.solicitacao.emailTerceiro = pessoa.email.substring(0, 300);
            this.solicitacao.solicitacao.inss = pessoa.inss;
            this.solicitacao.solicitacao.identidade = pessoa.identidadeInscEstadual.substring(0, 20);
            this.solicitacao.solicitacao.inscricaoMunicipal = pessoa.identidadeInscMunicipal.substring(0, 20);
            if (pessoa.dataNascimento) {
              this.solicitacao.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
            }
            this.dadosBancarios = pessoa.dadosBancarios;
            
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.solicitacao.documentoTerceiro = this.documento;
            
			      this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolPagamentoPJ || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolPagamentoPJ.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosPagamento.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.$refs.dadosProjetos.validarProjeto)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-projetos"]').tab('show');
              this.$refs.dadosProjetos.validar();
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-pagamento-rateio-pj.relatorio', id, 'solicitacao-pagamento-rateio-pj');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (this.$route.params.id) {
          return solicitacaoPagamentoServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoPagamentoServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
        }
      },
            camposSolicitacao() {
        return {
          idSolicitacao: 0,
          solicitacao: {
            idCoordenador: '',
            dataSolicitacao: '',
            dataPagamento: '',
            documentoTerceiro: '',
            nomeTerceiro: '',
            observacao: '',
            solicitacaoEfetivada: '',
            formaPagamento: '',
            agencia: '',
            banco: '',
            contaCorrente: '',
            valor: '',
            pertenceQuadro: false,
            tipoQuadro: '',
            matricula: '',
            outroQuadro: '',
            dataNascimento: '',
            identidade: '',
            inss: '',
            pisPasep: '',
            cmc: '',
            numCmc: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            cep: '',
            uf: '',
            telefoneResidencial: '',
            telefoneComercial: '',
            fax: '',
            tipoPagamento: '',
            statusSolicitacao: '',
            dataLiberacao: '',
            observacaoLiberacao: '',
            liberacaoCoordenador: '',
            dadosVerificados: '',
            totalReenvio: '',
            siafi: '',
            tipoConta: '',
            idUsuario: '',
            pagamentoDiaria: '',
            pagamentoDeBolsa: false,
            liberacaoCoordenador2: '',
            idRubrica: '',
            idSubrubrica: '',
            idConta: '',
            idProtocolo: '',
            tipoSolicitacao: 2,
            emailTerceiro: '',
            idResponsavelSolicitacao: '',
            idUsuarioResponsavel: '',
            justicicativa: '',
            descricao: '',
            idDetalheRateio: '',
            idCategoriaFinanceira: '',
            inssOutraFonte: false,
            inssOutraFonteValor: '',
            nomeSolicitante: '',
            emailSolicitante: '',
            telefoneSolicitante: '',
            notaFiscal: '',
            dataEmissao: '',
            dataVencimento: '',
            inscricaoMunicipal: '',
            nomeSolicitante: '',
            emailSolicitante: '',
            telefoneSolicitante: '',
            rateio: {
              idProjeto: '',
              valorRateio: '',
              idDetalheRateio: '',
              idProjetoMetaEtapa: '',
            },
          },
          solicitacaoHasSolicitacao: [],
          solicitacaoPagamentoRateio: [],
        };
      },
      limparDadoBancario() {
        if (this.solicitacao.solicitacao.formaPagamento !== 0) {
          this.solicitacao.solicitacao.banco = '';
          this.solicitacao.solicitacao.agencia = '';
          this.solicitacao.solicitacao.contaCorrente = '';
          this.solicitacao.solicitacao.tipoConta = '';
        }
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoPagamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.solicitacao.documentoTerceiro);
          })
          .then(() => {
            solicitacao.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.solicitacao.dataNascimento);
            solicitacao.solicitacao.dataEmissao = this.$options.filters.formatarNumeroEmData(solicitacao.solicitacao.dataEmissao);
            solicitacao.solicitacao.dataVencimento = this.$options.filters.formatarNumeroEmData(solicitacao.solicitacao.dataVencimento);
            solicitacao.solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.solicitacao.dataPagamento);
          })
          .then(() => solicitacaoPagamentoServico.arquivos(id,"-1"))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.carregando = false;
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      limparInssOutraFonte() {
        if (!this.solicitacao.solicitacao.inssOutraFonte) {
          this.solicitacao.solicitacao.inssOutraFonteValor = null;
        }
      },
      limparPertenceQuadro() {
        if (!this.solicitacao.solicitacao.pertenceQuadro) {
          this.solicitacao.solicitacao.tipoQuadro = '';
        }
      },
      download(arquivo) {
        solicitacaoPagamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
      'solicitacao.solicitacao.formaPagamento': 'limparDadoBancario',
      'solicitacao.solicitacao.inssOutraFonte': 'limparInssOutraFonte',
      'solicitacao.solicitacao.pertenceQuadro': 'limparPertenceQuadro',
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Dados cadastrais
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-pagamento">
                  Dados para o pagamento
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-projetos">
                  Dados projetos
                </a>
              </li>
              <li :class="{'disabled': solicitacao.solicitacao.formaPagamento !== 0}">
                <a @click.prevent=""
                   :data-toggle="solicitacao.solicitacao.formaPagamento === 0 ? 'tab' : ''"
                   href="#tab-dados-bancarios">
                  Dados bancários
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :solicitacao="solicitacao.solicitacao"
                                    :edicao="!!$route.params.id">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-dados-pagamento" class="tab-pane">
                <div class="panel-body">
                  <dados-pagamento ref="dadosPagamento"
                                   :solicitacao="solicitacao.solicitacao"
                                   :edicao="!!$route.params.id">
                  </dados-pagamento>
                </div>
              </div>

              <div id="tab-dados-projetos" class="tab-pane">
                <div class="panel-body">
                  <dados-projetos ref="dadosProjetos"
                                  :solicitacao="solicitacao"
                                  :edicao="!!$route.params.id">
                  </dados-projetos>
                </div>
              </div>

              <div id="tab-dados-bancarios" class="tab-pane">
                <div class="panel-body">
                  <dados-bancarios ref="dadosBancarios"
                                   :solicitacao="solicitacao.solicitacao"
                                   :edicao="!!$route.params.id"
                                   :dadosBancarios="dadosBancarios">
                  </dados-bancarios>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      
      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">CNPJ da Empresa Beneficiária</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="documento"
                   data-vv-name="documento"
                   v-mascara="'cnpj'"
                   v-validate="'required|cnpj'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link 
                class="btn btn-default" 
                :to="{ name: 'solicitacao-pagamento-rateio-pj' }" 
                v-show="!mostrarFormulario || !!$route.params.id" 
                active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
                id="avancar"
                type="button" 
                class="btn btn-primary" 
                @click="validarBeneficiario" 
                v-show="!mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar 
              <i class="fa fa-arrow-right"></i>
            </button>
            
            <button 
                type="button" 
                class="btn btn-default" 
                @click="mostrarFormulario = false, resetarComponente()" 
                v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta 
            </button>

            <button 
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar" 
                v-show="mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar 
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento-rateio/juridica/componentes/SolicitacaoPagamentoPjForm.vue